import { Component, OnInit } from '@angular/core'
import { BaseComponent } from 'src/app/_shared/utils/base-component'
import { RequestsService } from 'src/app/_shared/services/requests.service'

@Component({
  selector: 'app-india-management-dashboard',
  templateUrl: './india-management-dashboard.component.html',
  styleUrls: ['./india-management-dashboard.component.scss'],
})
export class IndiaManagementDashboardComponent
  extends BaseComponent
  implements OnInit
{
  dateRange = true
  public ordersChartLabels = []
  public doughnutChartLabels = []
  public doughnutChartData = []
  public ordersChartData = []
  public doughnutChartType = 'doughnut'
  public options: any = {
    legend: {
      position: 'right',
      labels: {
        padding: 5,
      },
    },
  }

  public doughnutChartColors: Array<any> = [
    {
      backgroundColor: [
        '#CDC50B',
        '#F14E75',
        '#180BE3',
        '#0DE7EA',
        '#CE80A6',
        '#038F18',
        '#1AB8E3',
      ],
    },
  ]

  public doughnutChartDegree: any
  // stockValues = [];
  totalInquiries: number
  totalFarmers: number
  loaded = false
  totalWeather: number
  totalFertigation: number
  farmersOrders: Object
  totalNumberOfAgents: number = 0
  numberOfMasterAgents: number = 0
  numberOfVillageAgents: number = 0
  errorMessage: string
  totalCompletedOrders: number = 0
  farmerCropData: any
  farmerStateData: any
  farmerDetails: any
  fert_schedule_details: any
  inquiryDetails: any
  farmer_details: boolean = false
  schedule_details: boolean = false
  inquiry_details: boolean = false
  farmersCropDateset = []
  farmersStateDateset = []
  farmerCropLabes = []
  farmerStateLabes = []
  MAs: any
  // farmers = {};
  // vas;
  downloadsData: any
  actualDownloadsDataSet = []
  downloadsLabels = []
  downloadsDataSet = []
  totalDownloads: number
  farmPage = 1
  fertPage = 1
  inqPage = 1
  count = 10
  farmerDetailsFilter: any
  scheduleDetailsFilter: any
  searchItem: string
  inquiryDetailsFilter: any

  public farmerCropLabels = this.farmerCropLabes
  public farmerCropDataset = [
    { data: this.farmersCropDateset, label: 'Farmers' },
  ]
  public farmerCropDataType = 'bar'
  public farmerCropDataOptions = {
    responsive: true,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            precision: 0,
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            display: false,
          },
        },
      ],
    },
  }
  public farmerCropDataColors = [
    {
      backgroundColor: 'rgb(60,122,184)',
    },
  ]

  public farmerStateLabels = this.farmerStateLabes
  public farmerStateDataset = [
    { data: this.farmersStateDateset, label: 'Farmers' },
  ]
  public farmerStateDataType = 'bar'
  public farmerStateDataOptions = {
    responsive: true,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            precision: 0,
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            display: false,
          },
        },
      ],
    },
  }
  public farmerStateDataColors = [
    {
      backgroundColor: 'rgb(60,122,184)',
    },
  ]

  public downldsLabels = this.downloadsLabels
  public downloadsChartType = 'bar'
  public downloadsChartOptions = {
    responsive: true,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            maxTicksLimit: 11,
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            display: false,
          },
        },
      ],
    },
  }
  public downloadsDataColors = [
    {
      backgroundColor: 'rgb(60,122,184)',
    },
  ]

  constructor(requestService: RequestsService) {
    super(requestService)
  }

  ngOnInit() {
    this.getTheChartsData()
    this.getTheCountData()
    this.getDownloadsData()
  }

  getTheChartsData() {
    this.loaded = false

    this.loadData('india-dashboard-farmers').subscribe(
      (result) => {
        this.loaded = true
        this.farmerCropData = result.crop_data
        this.farmerStateData = result.state_data
        this.farmerCropData.map((each) => {
          this.farmerCropLabes.push(each.crop)
          this.farmersCropDateset.push(each.farmers)
        })

        this.farmerStateData.map((each) => {
          this.farmerStateLabes.push(each.state)
          this.farmersStateDateset.push(each.farmers)
        })
      },
      (error) => {
        this.errorMessage = 'Error loading payments data'
      }
    )
  }

  getTheCountData() {
    this.loaded = false

    this.loadData('india-count-data').subscribe(
      (result) => {
        this.loaded = true
        this.totalFarmers = result.farmer_count[0].farmer_count
        this.totalFertigation = result.fertigation_count[0].fertigation_count
        this.totalInquiries = result.inquiry_count[0].inquiry_count
        this.totalWeather = result.weather_count
        this.farmerDetails = result.farmer_details
        this.farmerDetailsFilter = result.farmer_details
        this.fert_schedule_details = result.fert_schedule_details
        this.scheduleDetailsFilter = result.fert_schedule_details
        this.inquiryDetails = result.inquiry_details
        this.inquiryDetailsFilter = result.inquiry_details
      },
      (error) => {
        this.errorMessage = 'Error loading payments data'
      }
    )
  }

  getDownloadsData() {
    this.loaded = false

    this.loadData('india-dashboard/downloads').subscribe(
      (res) => {
        this.loaded = true
        this.downloadsData = res.data.result
        this.totalDownloads = res.data.total_downloads

        this.downloadsData.map((each) => {
          const monthDate = new Date(each.month)
          const monthName = monthDate.toLocaleString('default', {
            month: 'long',
          })
          this.downloadsLabels.push(monthName)
          this.actualDownloadsDataSet.push(each.No_of_activations)

          this.downloadsDataSet = [
            {
              data: this.actualDownloadsDataSet,
              barPercentage: 1.0,
              label: `Actual (${this.totalDownloads})`,
            },
          ]
        })
      },
      (error) => {
        this.errorMessage = 'There was a problem loading downloads data'
      }
    )
  }

  displayFarmerDetails() {
    this.farmer_details = !this.farmer_details
    this.schedule_details = false
    this.inquiry_details = false
  }

  displayFertigationScheduleDetails() {
    this.schedule_details = !this.schedule_details
    this.farmer_details = false
    this.inquiry_details = false
  }

  displayInquiryDetails() {
    this.inquiry_details = !this.inquiry_details
    this.farmer_details = false
    this.schedule_details = false
  }

  filterFarmerDetails(event) {
    this.searchItem = event.target.value
    this.farmerDetailsFilter
      ? (this.farmerDetailsFilter = this.farmerDetails.filter(
          (data) =>
            data.farmer_name
              .toLowerCase()
              .indexOf(this.searchItem.toLowerCase()) !== -1
        ))
      : null
  }

  filterFarmerScheduleDetails(event) {
    this.searchItem = event.target.value
    this.scheduleDetailsFilter
      ? (this.scheduleDetailsFilter = this.fert_schedule_details.filter(
          (data) =>
            data.farmer_name
              .toLowerCase()
              .indexOf(this.searchItem.toLowerCase()) !== -1
        ))
      : null
  }

  filterInquiryDetails(event) {
    this.searchItem = event.target.value
    this.inquiryDetailsFilter
      ? (this.inquiryDetailsFilter = this.inquiryDetails.filter(
          (data) =>
            data.farmer_name
              .toLowerCase()
              .indexOf(this.searchItem.toLowerCase()) !== -1
        ))
      : null
  }
}
